import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    IsUserLoggedIn: false,
  },
  reducers: {
    loginSave: (state, action) => {
      state.user = action.payload;
    },
    logoutSave: (state) => {
      state.user = null;
    },
    userLoggedIn: (state, action) => {
      state.IsUserLoggedIn = action.payload;
    },
    userNotLoggedIn: (state) => {
      state.IsUserLoggedIn = false;
    }
  },
});

export const { loginSave, logoutSave, userLoggedIn, userNotLoggedIn } = userSlice.actions;

export const selectUser = (state) => state.user.user;

export const selectIsUserLoggedIn = (state) => state.user.IsUserLoggedIn;

export default userSlice.reducer;
